import { render, staticRenderFns } from "./FacilityDescription.vue?vue&type=template&id=6dac61a5&scoped=true&"
import script from "./FacilityDescription.vue?vue&type=script&lang=js&"
export * from "./FacilityDescription.vue?vue&type=script&lang=js&"
import style0 from "./FacilityDescription.vue?vue&type=style&index=0&id=6dac61a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dac61a5",
  null
  
)

export default component.exports